import { Pipe, PipeTransform } from '@angular/core';
import { VehiculeStatus } from 'src/app/shared/enums/vehicule-status-enum';
import { Vehicle } from 'src/app/shared/models/vehicle';

@Pipe({
	name: 'filterVehiculeByAllFields'
})
export class FilterVehiculeByAllFieldsPipe implements PipeTransform {
	transform(value: Vehicle[], filter: string): Vehicle[] {
		if (
			!value ||
			!filter ||
			value === null ||
			filter === null ||
			filter === ''
		) {
			return value;
		}
		filter = filter.toLowerCase();

		return value.filter(
			(vehicule) =>
				vehicule.name.toLowerCase().includes(filter) ||
				vehicule.model.toLowerCase().includes(filter) ||
				vehicule.status.toLowerCase().includes(filter) ||
				VehiculeStatus[vehicule.status].toLowerCase().includes(filter) ||
				vehicule.travelledDistance.toString().includes(filter) ||
				vehicule.mileageCost.toString().includes(filter)
		);
	}
}
